module.exports = __webpack_public_path__ + "static/media/others.61e1f431.svg";